import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import App from './App';
import LocaleProvider from './i18n/LocaleProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <LocaleProvider
    theme={{
      token: {
        fontFamily:
          '"Alibaba PuHuiTi", "Microsoft YaHei", "微软雅黑", "PingFang SC", "Hiragino Sans GB", "Segoe UI", sans-serif'
      }
    }}>
    <App />
  </LocaleProvider>
);
